<div class="mat-paginator float-end d-inline-block py-4">{{'GLOBAL.ITEMS' | translate}} 1 - {{totalItems}} {{'GLOBAL.OF' | translate}} {{totalItems}}</div>
